<template>
  <div>
    <el-card
      class="box-card"
      shadow="never"
    >
      <div
        slot="header"
        class="card-header"
      >
        <span>商品管理</span>
        <el-button
          type="primary"
          size="small"
          plain
          @click="goodsVisible = true"
        >
          编辑商品
        </el-button>
      </div>
      <div>
        <div
          v-if="goods"
          class="goods-box"
        >
          <ul class="goods-list">
            <li class="item">
              <img
                :src="goods.pic"
                class="item-img"
              >
              <div class="item-info">
                <h4 class="title">
                  {{ goods.item_name }}
                </h4>
                <p
                  v-if="goods.sku != ''"
                  class="sku"
                >
                  {{ goods.sku }}
                </p>
              </div>
            </li>
          </ul>
        </div>
        <div
          v-else
          class="meter-text"
        >
          请选则商品
        </div>
      </div>
    </el-card>
    <!-- 选择商品 -->
    <GoodsSelect
      :goods-visible="goodsVisible"
      choose-one
      @closeGoodsDialog="closeGoodsDialog"
      @chooseGoods="chooseGoods"
    />
  </div>
</template>

<script>
import GoodsSelect from '@/components/goodsSelect'
export default {
  components: {
    GoodsSelect
  },
  model: {
    prop: 'goods',
    event: 'goodsChange'
  },
  props: {
    goods: {
      type: Object
    }
  },
  data () {
    return {
      goodsVisible: false
    }
  },
  methods: {
    closeGoodsDialog () {
      this.goodsVisible = false
    },
    // 选择图片
    chooseGoods (selectdata) {
      console.log(selectdata, '选择的商品')
      let goods = selectdata[0]
      this.goodsVisible = false
      this.$emit('goodsChange', goods)
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-box {
  overflow: hidden;
  zoom: 1;
  .goods-list {
    .item {
      // border: 1px solid rgba(0, 0, 0, 0.05);
      padding: 8px;
      margin-bottom: 8px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      .num {
        position: absolute;
        left: 0;
        top: 0;
        width: 16px;
        height: 16px;
        background: rgba(0, 0, 0, 0.25);
        text-align: center;
        line-height: 16px;
        color: #fff;
        font-size: 12px;
      }
      &-img {
        width: 52px;
        height: 52px;
      }
      &-info {
        flex: 1;
        padding-left: 20px;
        .title {
          font-size: 14px;
          color: #262626;
          height: 28px;
          line-height: 28px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .sku {
          font-size: 12px;
          color: #262626;
          height: 22px;
          line-height: 22px;
        }
      }
    }
  }
}
.meter-text {
  font-size: 12px;
  color: #999;
  line-height: 20px;
  margin-bottom: 12px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

::v-deep {
  .el-card__header {
    padding: 5px 20px;
  }
}
.box-card {
  margin-bottom: 20px;
}
</style>
